import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import "bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js";

// Required for jQuery plugins to work in modern setups
window.$ = $;
window.jQuery = $;

const BootstrapDatepicker = ({ onChange }) => {
  const datepickerRef = useRef(null);

  useEffect(() => {
    const $el = $(datepickerRef.current);
    const today = new Date();

    $el.datepicker({
      format: "yyyy-mm",
      startView: 1,
      minViewMode: 1,
      autoclose: true,
    });

    $el.datepicker("setDate", today);

    // Use a stable wrapper to avoid infinite loops
    const handleChange = (e) => {
      if (typeof onChange === "function") {
        onChange(e.date);
      }
    };

    $el.on("changeDate", handleChange);

    return () => {
      $el.datepicker("destroy");
      $el.off("changeDate", handleChange);
    };
    // IMPORTANT: Do not include `onChange` as dependency to avoid infinite loop
  }, []);

  return (
    <div className="form-group">
      <input
        type="text"
        className="form-control"
        ref={datepickerRef}
        placeholder="YYYY-MM"
        readOnly // Optional: helps prevent keyboard date typing
      />
    </div>
  );
};

export default BootstrapDatepicker;
